<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" :label-position="labelPosition" label-width="125px">
          <el-row :gutter="16">
            <el-col :span="7">
              <el-form-item label="发出库存节点名称">
                <el-input class="handle-input" v-model="queryCondition.mateName" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="接受库存节点名称">
                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="流水号">
                <el-input class="handle-input" v-model="queryCondition.mateName" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="7">
              <el-form-item label="出库单号">
                <el-input class="handle-input" v-model="queryCondition.mateCode" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="出库类型">
                <el-select v-model="queryCondition.materialName" class="handle-input">
                  <el-option key="1" label="满箱出库" value="满箱出库"></el-option>
                  <el-option key="2" label="空箱出库" value="空箱出库"></el-option>
                  <el-option key="3" label="维修出库" value="维修出库"></el-option>
                  <el-option key="4" label="改制出库" value="改制出库"></el-option>
                  <el-option key="5" label="报废出库" value="报废出库"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="状态">
                <el-select v-model="queryCondition.materialName" class="handle-input">
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="出库时间">
                <el-date-picker class="handle-input" v-model="queryCondition.date" type="daterange" range-separator="To" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-button type="primary" @click="queryData">搜索</el-button>
              <el-button type="primary">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button type="primary" @click="downloadMatePart">新增</el-button>
        <el-button type="primary" @click="downloadMatePart">下载</el-button>
        <el-button type="primary" @click="downloadMatePart">生成PDF</el-button>
      </el-row>
      <el-table :data="tableData" border highlight-current-row class="table" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="mateCode" label="出库单号">
          <template slot-scope="scope">
            <router-link class="a-link" replace :to="{name: 'out-store-order-edit', params:{nodeName: scope.row.mateCode}}">{{scope.row.mateCode}}</router-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="no" label="出库类型"></el-table-column>
        <el-table-column show-overflow-tooltip prop="mateName" label="发出库存节点名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="createDate" label="发出库存节点编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="status" label="接收库存节点名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="status" label="接收库存节点编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="status" label="出库日期"></el-table-column>
        <el-table-column show-overflow-tooltip prop="status" label="流水号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="status" label="创建人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="status" label="最后更新日期"></el-table-column>
        <el-table-column show-overflow-tooltip prop="status" label="状态"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'out-store-order',
  data() {
    return {
      tableData: [{
        mateCode: '123456',
        no: '00000000',
        mateName: 'red',
        createDate: '2019-09-09',
        status: '9999'
      }],
      total: 0,
      labelPosition: 'right',
      queryCondition: {
        mateCode: '',
        status: '',
        date: '',
        materialNo: '',
        materialName: ''
      },
      applyForm: {
        mateCode: '',
        mateName: '',
        applyCount: 0
      },
      applyDialog: false
    }
  },
  methods: {
    queryData() {
      console.dir(this.queryCondition);
    },
    /**
     * 翻页事件
     */
    handleCurrentChange() {

    },
    downloadMatePart() {

    },
    handleSelectionChange() {

    }
  }
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}
.query-btn-row {
  width: 30%;
  float: right;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.dialog-input {
  width: 40%;
}
</style>